import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { AnalisisDemandaService } from 'src/app/services/analisis-demanda.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-modal-pedidos',
  templateUrl: './modal-pedidos.component.html',
  styleUrls: ['./modal-pedidos.component.scss'],
  providers: [SecurityService],
})
export class AnalisisDemandaModalPedidosComponent implements OnInit {

  // Modales
  @ViewChild('pedidos', { static: true }) modalPedidos: ModalDirective;

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  loading: boolean = false
  detalleProducto: any = null
  listaMovimientos: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private analisisDemandaService: AnalisisDemandaService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
  ) {
    this.log = this.clog.log('ANALISIS-DEMANDA-PEDIDOS')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10
  }

  public loadAndShow(detalleProducto) {
    this.log('loadAndShow', detalleProducto)
    this.detalleProducto = detalleProducto
    this.modalPedidos.show()
    this.buscar(1)
  }

  buscar(pageNumber: number) {

    this.paginationContext.CurrentPage = pageNumber

    this.listaMovimientos = null

    const { producto_formato, producto_codigo } = this.detalleProducto
    const inputParams = {
      empresa_rut: this.rutEmpresa,
      sucursalCodigo: this.sucursalCodigo,
      listaFormatos: [producto_formato],
      producto_codigo: producto_codigo,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.analisisDemandaService.ObtenerSegunProducto(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaMovimientos = registros
      this.listaMovimientos.map(registro => {
        registro.rutFormato = this.rutService.AgregarDV(registro.cliente_proveedor_rut)
      })
      this.loading = false
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

}
